// Slick sliders
$(document).ready(function () {
    slickSlider();
    lazySlider();
});


$(window).on('load', function () {
    lazySlider();
});


// On window.scroll
$(window).on('scroll', function () {
    lazySlider();
});

function lazySlider() {
    $('.slider-lazy.slick-initialized').each(function() {
        let sliderStart = Math.ceil($(this).offset().top);
        let sliderHeight = Math.ceil($(this).outerHeight());
        let sliderEnd = Math.ceil($(this).offset().top + $(this).outerHeight());

        $(this).attr('data-lazy-slider');

        if ((g_scroll + g_windowHeight) > (sliderStart - (g_windowHeight/2))) {
            $(this).find('img').each(function() {
                let imageSrc = $(this).attr('data-src');
                $(this).attr('data-lazy', imageSrc);
                $(this).removeAttr('data-src');
            });
            $(this).attr('data-lazy-slider', 'loaded');
            $(this).slick('slickGoTo', 0);
            $(this).removeAttr('data-lazy-slider');
        }
    });
}

function slickSlider() {
    if ($('.slider').length > 0) {
        $('.slider').slick({
            dotsClass: 'slick-dots inside-dots',
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            draggable: true,
            autoplay: false,
            infinite: false,
            fade: true,
            arrows: false,
            dots: true,
            speed: 1000,
            rows: 0
        });
    }

    if ($('.slider-media').length > 0) {
        $('.slider-media').slick({
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 4,
            draggable: true,
            autoplay: false,
            infinite: true,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [{
                breakpoint: 960,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2
                }
            }]
        });
    }

    if ($('.slider-videos').length > 0) {
        $('.slider-videos').slick({
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 2,
            draggable: true,
            autoplay: false,
            infinite: false,
            arrows: false,
            dots: true,
            speed: 500,
            rows: 0,
            responsive: [{
                breakpoint: 450,
                settings: {
                    slidesToShow: 1
                }
            }]
        });
    }

    if ($('.slider-product').length > 0) {
        $('.slider-product').slick({
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 1,
            draggable: true,
            autoplay: false,
            infinite: false,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0
        });
    }

    if ($('.slider-nav').length > 0) {
        $('.slider-nav').slick({
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 3,
            draggable: true,
            autoplay: false,
            infinite: false,
            arrows: false,
            dots: false,
            speed: 500,
            rows: 0,
            focusOnSelect: true
        });
    }

    if ($('.slider-related-products').length > 0) {
        $('.slider-related-products').slick({
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 4,
            draggable: true,
            autoplay: false,
            infinite: false,
            arrows: true,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [{
                breakpoint: 960,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 710,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 550,
                settings: {
                    slidesToShow: 1
                }
            }]
        });
    }
}
